import { useEffect, useState } from "react";
import { API, apiError, formatDateTime } from "../lib/api";
import { toast } from "sonner";

const ACTION_COLORS = {
  LOGIN: "tag-info", LOGOUT: "tag-muted",
  SALE_CREATE: "tag-success", SALE_RETURN: "tag-warning",
  STOCK_ADD: "tag-success", STOCK_UPDATE: "tag-info", STOCK_DELETE: "tag-danger",
  USER_CREATE: "tag-success", USER_UPDATE: "tag-info", USER_DELETE: "tag-danger",
  BRANCH_CREATE: "tag-success", BRANCH_UPDATE: "tag-info", BRANCH_DELETE: "tag-danger",
  EXPENSE_CREATE: "tag-info", EXPENSE_DELETE: "tag-danger",
};

export default function ActivityLog() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("");

  useEffect(() => {
    API.get("/activity-log", { params: { limit: 500 } })
      .then((r) => setLogs(r.data))
      .catch((e) => toast.error(apiError(e)))
      .finally(() => setLoading(false));
  }, []);

  const filtered = logs.filter((l) => {
    if (!filter) return true;
    const t = filter.toLowerCase();
    return l.user_email?.toLowerCase().includes(t) || l.action?.toLowerCase().includes(t) || l.details?.toLowerCase().includes(t);
  });

  return (
    <div className="p-4 sm:p-6 md:p-8 space-y-5" data-testid="activity-log-page">
      <div>
        <div className="overline mb-2">Audit Trail</div>
        <h1 className="font-display text-3xl font-bold">Activity Log</h1>
        <p className="text-sm text-slate-500 mt-1">Every login, sale, stock change and admin action is logged here.</p>
      </div>

      <input
        value={filter} onChange={(e) => setFilter(e.target.value)}
        data-testid="activity-filter"
        placeholder="Filter by user, action or details..."
        className="w-full max-w-md border border-slate-200 rounded-lg px-3.5 py-2 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-[#002FA7]/20 focus:border-[#002FA7]"
      />

      <div className="bg-white border border-slate-200 rounded-xl overflow-hidden">
        {loading ? <div className="p-10 text-center text-slate-500 text-sm">Loading…</div> : (
          <div className="overflow-x-auto max-h-[70vh]">
            <table className="data-table">
              <thead><tr><th>Time</th><th>User</th><th>Role</th><th>Action</th><th>Details</th><th>IP</th></tr></thead>
              <tbody>
                {filtered.map((l) => (
                  <tr key={l.id}>
                    <td className="text-xs whitespace-nowrap">{formatDateTime(l.timestamp)}</td>
                    <td>
                      <div className="font-medium">{l.user_name}</div>
                      <div className="text-xs text-slate-500">{l.user_email}</div>
                    </td>
                    <td><span className="tag tag-muted capitalize">{l.role}</span></td>
                    <td><span className={`tag ${ACTION_COLORS[l.action] || "tag-muted"}`}>{l.action}</span></td>
                    <td className="text-slate-600 max-w-md truncate">{l.details || "—"}</td>
                    <td className="font-mono text-xs text-slate-400">{l.ip}</td>
                  </tr>
                ))}
                {filtered.length === 0 && <tr><td colSpan={6} className="text-center text-slate-500 text-sm py-10">No entries.</td></tr>}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
